/**
 * ? @description : Student Details Modal
 */

// Dependencies
import React, { Fragment } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import SessionPerformance from "./SessionPerformance";

// CSS
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import Axios from "../../../../../axios/Axios";
import { showSnackbar } from "../../../../redux/features/appSlice";
import { useDispatch } from "react-redux";


function StudentDetails(props) {
  // console.log(props);
  // ? State Variables
  const dispatch = useDispatch();
  // const [sessionDetails, setSessionDetails] = useState([]);
  
  // console.log(props);
  // ? Mock Data
  // const sessionData = [
  //   {
  //     session_name: "Session 1",
  //     class_name: "Class 1",
  //     session_status: "In Progress",
  //     session_date: "2022-09-01",
  //   },
  //   {
  //     session_name: "Session 1",
  //     class_name: "Class 2",
  //     session_status: "Completed",
  //     session_date: "2022-09-02",
  //   },
  //   {
  //     session_name: "Session 2",
  //     class_name: "Class 1",
  //     session_status: "In Progress",
  //     session_date: "2022-09-03",
  //   },
  //   {
  //     session_name: "Session 2",
  //     class_name: "Class 2",
  //     session_status: "Completed",
  //     session_date: "2022-09-04",
  //   },
  // ];

  // ? Fetch Student Details
  // useEffect(() => {
    
  // }, []);

  // ? Column Definitions
  const columns = [
    {
      headerName: "Session Name",
      field: "session_name",
      filter: true,
      sortable: true,
    },
    {
      headerName: "Session Status",
      field: "session_status",
      filter: true,
      sortable: true,
    },
    {
      headerName: "Session Date",
      field: "session_date",
      filter: true,
      sortable: true,
      cellRenderer: (params) => {
        return params.value.slice(0, 10);
      }
    },
  ];

  // ? API Call for Filter Table Data
  const onGridReady = async (params) => {
    if(props.selecteddata[0] && props.selecteddata[2] && props.selecteddata[2] !== "-"){
      try {
        let body = {stud_id: props.selecteddata[0], level_id: props.selecteddata[2]}
        const response = await Axios("post", "student/session/studentsessiondetails", true, body);
        // console.log(response);
        // setSessionDetails(response.data)
        params.api.applyTransaction({ add: response.data });
      } catch (error) {
        dispatch(
          showSnackbar({
            message: "Error occurred ! Unable to get session details.",
            severity: "error",
          })
        );
      }
    }
    
  };

  // ? Row Selection Type
  const rowSelectionType = "multiple";

  // ? Selected Row Data in State Function
  const onSelectionChanged = (event) => {
    console.log(event.api.getSelectedRows());
  };
  // console.log(sessionDetails);
  return (
    <Fragment>
      {props.selecteddata.length > 0 && (
        <Dialog
          open={props.open}
          onClose={props.onClose}
          maxWidth="lg"
          fullWidth
          aria-labelledby="dialog-title"
          aria-describedby="dialog-content"
        >
          <DialogTitle id="dialog-title">
            Detailed Report of Student : {props.selecteddata[1]}
          </DialogTitle>

          <DialogContent>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                }}
              >
                <Box
                  className="ag-theme-alpine"
                  sx={{ mt: "16px", height: "330px", width: "100%" }}
                >
                  <AgGridReact
                    defaultColDef={{ flex: 1 }}
                    onGridReady={onGridReady}
                    // rowData={sessionDetails}
                    columnDefs={columns}
                    rowSelection={rowSelectionType}
                    onSelectionChanged={onSelectionChanged}
                    rowMultiSelectWithClick={true}
                    pagination={true}
                    paginationPageSize={5}
                  />
                </Box>
                <Box sx={{ height: "270px", width: "270px" }}>
                  <SessionPerformance {...props.selecteddata}></SessionPerformance>
                </Box>
              </Box>
          </DialogContent>

          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              ml: "16px",
              mb: "8px",
            }}
          >
            <Box>
              <Button
                type="button"
                variant="contained"
                color="inherit"
                onClick={() => { 
                  props.onClose()}
                }
              >
                close
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}
    </Fragment>
  );
}

export default StudentDetails;
